module.exports = __webpack_public_path__ + "img/symbol_3.57f6479c.png";